'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherInfo, FeatherTrendingUp } from '@subframe/core';
import { Button, Dialog } from '@/shared/components/ui';
import type { TrialTenant } from '../types';
import { formatarDataCurta } from '../utils/trialDateUtils';
interface ConverterTrialModalProps {
  isOpen: boolean;
  trial: TrialTenant | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}
export function ConverterTrialModal(t0) {
  const $ = _c(32);
  const {
    isOpen,
    trial,
    saving,
    onClose,
    onConfirm
  } = t0;
  if (!trial) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherTrendingUp className="text-brand-600 h-5 w-5" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="text-body-bold font-body-bold text-default-font">Converter trial em plano pago</h2>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = trial.tenantNome;
  let t4;
  if ($[2] !== trial.dataExpiracao) {
    t4 = formatarDataCurta(trial.dataExpiracao);
    $[2] = trial.dataExpiracao;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4 || $[5] !== trial.tenantNome) {
    t5 = <p className="text-caption font-caption text-subtext-color mt-1">{t3} · em trial até {t4}</p>;
    $[4] = t4;
    $[5] = trial.tenantNome;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== trial.produtoNome) {
    t6 = <p className="text-caption font-caption text-brand-700 mt-1">Produto: <span className="font-semibold">{trial.produtoNome}</span></p>;
    $[7] = trial.produtoNome;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex items-start gap-3">{t1}<div className="flex-1">{t2}{t5}{t6}</div></div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherInfo className="text-brand-700 mt-0.5 h-4 w-4 shrink-0" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="border-brand-100 bg-brand-50 flex items-start gap-3 rounded-[8px] border px-4 py-3 text-sm">{t8}<div className="text-brand-800"><p className="font-semibold">O contrato muda de TRIAL para ATIVO imediatamente.</p><p className="mt-0.5">As condições comerciais configuradas no início do trial (modalidade, método de pagamento, dia de vencimento) passam a valer. Pode ajustá-las depois pela aba Contratos.</p></div></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onClose || $[15] !== saving) {
    t10 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[14] = onClose;
    $[15] = saving;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== onConfirm) {
    t11 = () => void onConfirm();
    $[17] = onConfirm;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== saving || $[20] !== t11) {
    t12 = <Button variant="brand-primary" size="medium" loading={saving} disabled={saving} onClick={t11}>Converter para plano pago</Button>;
    $[19] = saving;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12) {
    t13 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t10}{t12}</div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t7) {
    t14 = <Dialog.Content className="max-w-md"><div className="flex w-full flex-col gap-5 p-6">{t7}{t9}{t13}</div></Dialog.Content>;
    $[25] = t13;
    $[26] = t7;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== isOpen || $[29] !== onClose || $[30] !== t14) {
    t15 = <Dialog open={isOpen} onOpenChange={onClose}>{t14}</Dialog>;
    $[28] = isOpen;
    $[29] = onClose;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}